import React from "react";
const AttRecordTable = ({ employeeAttendance }) => {
  // console.log(employeeAttendance)
  const tableHead = `py-3 px-3 border-b text-left  font-bold text-[14px] lg:text-lg`;
  const tableBody = `px-3 py-2 border-b font-semibold text-left`;
  return (
    <div className="">
      <div className="w-full h-[calc(100vh-170px)] overflow-y-auto mt-2 md:mt-3">
        <table className="min-w-max w-full border border-gray-300 pt-5">
          <thead className="bg-primaryPurple !text-white md:sticky w-full h-full p-0 top-0  z-10 ">
            <tr className="text-center w-full h-[20px]">
              <th className={`${tableHead}`}>Date</th>
              <th className={`${tableHead}`}>Entry Time</th>
              <th className={`${tableHead}`}>Leaving Time</th>
              <th className={`${tableHead}`}>Device</th>
              <th className={`${tableHead}`}>Work Type</th>
              <th className={`${tableHead}`}>Hours</th>
              <th className={`${tableHead}`}>Total Hours</th>
            </tr>
          </thead>
          <tbody>

            {employeeAttendance && Object.keys(employeeAttendance).map((dept) => (
              <>
                <tr>

                  <td colSpan={7} >
                    <div className="flex justify-end ">
                      <p className="py-4 px-3 border-b font-bold text-[18px] capitalize bg-gray-300 text-black rounded-full text-center ">
                        {dept}
                      </p>
                    </div>
                  </td>
                </tr>
                 
                {employeeAttendance[dept].map((employee) => (
                  <>
                    <tr className="">
                      <td className="flex justify-start">
                        <p className="py-4 px-3 border-b font-bold text-[18px] capitalize bg-gray-300 text-black rounded-r-full text-center min-w-[50%]">
                          {employee?.firstname}
                        </p>
                      </td>
                    </tr>
                    {(() => {
                      let totalHours = 0;
                      let totalMinutes = 0;
                      let totalLate = 0;
                      let totalAbsent = 0;
                      let totalPresent = 0;
                      let totalHoliday = 0;
                      let totalLeave = 0;
                      let totalDays = 0;
                      let totalOnsiteDays = 0;
                      let totalRemoteDays = 0;
                      employee?.attendanceData?.forEach((attendance) => {
                        if (attendance.totalHours) {
                          const [hours, minutes] = attendance.totalHours.split(":").map(Number);
                          totalHours += hours;
                          totalMinutes += minutes;
                        }
                        if (attendance.late == "Late") {
                          totalLate += 1
                        }
                        if (attendance?.entryTime != null) {
                          totalPresent += 1
                        }
                        if (attendance.dayType === "Absent") {
                          totalAbsent += 1
                        }
                        if (attendance.dayType === "Leave") {
                          totalLeave += 1
                        }
                        if (attendance.workType == "Onsite") {
                          totalOnsiteDays += 1
                        }
                        if (attendance.workType == "Remote") {
                          totalRemoteDays += 1
                        }
                        if (!attendance?.entryTime &&
                          attendance?.dayType === "Holiday" &&
                          attendance?.remark !== "SATURDAY" &&
                          attendance?.remark !== "SUNDAY") {
                          totalHoliday += 1
                        }
                        // update eg: add entrytime is exist
                        if (attendance?.entryTime  || (attendance.dayType !== "Weekend" &&
                          attendance.remark !== "SATURDAY" &&
                          attendance.remark !== "SUNDAY")) {
                          totalDays += 1
                        }
                      });
                      // console.log("totalAbsent",totalPresent)
                      totalHours += Math.floor(totalMinutes / 60);
                      totalMinutes = totalMinutes % 60;
                      const formattedMinutes = String(totalMinutes).padStart(2, "0");
                      return (
                        <>
                          {employee.attendanceData.map((attendance, index) => (
                            <tr className={`${attendance.remark == "SUNDAY" || attendance.remark == "SATURDAY" ? "bg-blue-300" :
                              attendance.remark === "Absent" || attendance.remark == "Sick Leave" || attendance.remark == "Annual Leave" ? "bg-red-300" :
                                attendance.late === 'Late' ? 'bg-yellow-100' :
                                  attendance.remark === 'present' ? 'bg-white' : 'bg-green-100'}`}
                              key={index}>
                              <td className={`${tableBody}`}>
                                {attendance.date}
                                <span className="">{attendance?.remark !== 'Annual Leave' && attendance?.remark !== 'Sick Leave' && attendance?.remark !== 'Absent' && attendance?.remark !== 'present' && attendance?.remark !== 'SATURDAY' && attendance?.remark !== 'SUNDAY' && `(${attendance?.remark})`}</span>
                              </td>
                              <td className={`${tableBody}`}>
                                {attendance.entryTime ? `${attendance.entryTime} ${attendance?.internetName ? `(${attendance?.internetName})` : ""}` : attendance.remark != "Absent" && attendance.leaveRemark ? `${attendance.remark} (${attendance.leaveRemark})` : attendance.remark}
                              </td>
                              <td className={`${tableBody}`}>{`${attendance?.leavingTime ? attendance?.leavingTime :""} ${(attendance?.timeoutinternetname ? `(${attendance?.timeoutinternetname})` : "")}`}</td>
                              <td className={`${tableBody}`}>{`${ attendance?.createdBy ? attendance?.createdBy?.split('|')[0].trim() : ""} `}</td>
                              <td className={`${tableBody}`}>{`${attendance.workType ? attendance.workType : ""} ${attendance.remoteReason ? `(${attendance.remoteReason.slice(0, 20) + "..."})` : ""}`}</td>
                              <td className={`${tableBody}`}>{attendance.hours}</td>
                              <td className={`${tableBody}`}>{attendance.totalHours}</td>
                            </tr>
                          )
                          )}
                          <tr className="bg-gray-100 text-sm">
                            {/* Total Days */}
                            <td className="py-4 px-3 border-b font-semibold text-gray-700">
                              <div className="flex flex-col items-start">
                                <span className="text-gray-500 text-xl">Total Days  <span className="text-lg text-black text-center">{totalDays}</span></span>
                                {/* <span className="text-lg text-black text-center">{totalDays}</span> */}
                              </div>
                            </td>

                            {/* Present + Absent */}
                            <td className="py-4 px-3 border-b font-semibold">
                              <div className="flex flex-col gap-1">
                                <span className="flex items-center gap-2  bg-white px-2 py-1 rounded">
                                  <span className="text-lg">Present</span>
                                  <span className="font-bold text-lg">{totalPresent}</span>
                                </span>
                                <span className="flex items-center gap-2 bg-red-100 text-red-800 px-2 py-1 rounded">
                                  <span className="text-lg">Absent</span>
                                  <span className="font-bold text-lg">{totalAbsent}</span>
                                </span>
                              </div>
                            </td>

                            {/* Holiday + Leave */}
                            <td className="py-4 px-3 border-b font-semibold">
                              <div className="flex flex-col gap-1">
                                <span className="flex items-center gap-2 bg-green-100 text-green-800 px-2 py-1 rounded">
                                  <span className="text-lg">Holiday</span>
                                  <span className="font-bold text-lg">{totalHoliday}</span>
                                </span>
                                <span className="flex items-center gap-2 bg-purple-100 text-purple-800 px-2 py-1 rounded">
                                  <span className="text-lg">Leave</span>
                                  <span className="font-bold text-lg">{totalLeave}</span>
                                </span>
                              </div>
                            </td>
                            <td className="py-4 px-3 border-b font-semibold">
                              <div className="flex flex-col gap-1">
                                <span className="flex items-center gap-2 bg-white text-green-800 px-2 py-1 rounded">
                                  <span className="text-lg">Onsite</span>
                                  <span className="font-bold text-lg">{totalOnsiteDays}</span>
                                </span>
                                <span className="flex items-center gap-2 bg-white text-green-800 px-2 py-1 rounded">
                                  <span className="text-lg">Remote</span>
                                  <span className="font-bold text-lg">{totalRemoteDays}</span>
                                </span>
                              </div>
                            </td>

                            {/* Lates */}
                            <td className="py-4 px-3 border-b font-semibold">
                              <div className="flex items-center gap-2 bg-yellow-100 text-yellow-800 px-3 py-2 rounded">
                                <span className="text-lg">Lates</span>
                                <span className="font-bold text-lg">{totalLate}</span>
                              </div>
                            </td>

                            {/* Total Hours */}
                            <td className="py-4 px-3 border-b font-semibold" colSpan={2}>
                              <div className="flex flex-col items-start">
                                <span className="text-gray-500 text-lg">Total Hours</span>
                                <span className="text-lg text-black">{`${totalHours}:${formattedMinutes}`}</span>
                              </div>
                            </td>
                          </tr>
                        </>
                      );
                    })()}
                  </>
                ))}
              </>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AttRecordTable;
